import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import PhilosophySection from "./components/PhilosophySection";
import IowaWaterSection from "./components/IowaWaterSection";
import PackagesSection from "./components/PackagesSection";
import FeaturesSection from "./components/FeaturesSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <div className="min-h-screen bg-dark-bg">
      <Navbar />
      <main>
        <HeroSection />
        <PhilosophySection />
        <IowaWaterSection />
        <PackagesSection />
        <FeaturesSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}